module.exports = __webpack_public_path__ + "static/media/Artboard15.8bc05578.png";